module.exports = __webpack_public_path__ + "img/20200508_163418.adde88f0.jpg";